import type { APITriplet, ModelTriplet } from '$lib/resource-type';
import {
  ComponentSubtypes,
  ServiceSubtypes,
  isBuiltinAPI,
  isBuiltinModel,
  type ComponentSubtype,
  type ServiceSubtype,
} from '$lib/rdk';

import CAMERATRANSFORMATTRIBUTES from './camera/camera-transform-attributes.md?raw';
import MOTIONATTRIBUTES from './motion/motion-service-attributes.md?raw';
import SERVOGPIOATTRIBUTES from './servo/servo-gpio-attributes.md?raw';

type ResourceSubtype = ComponentSubtype | ServiceSubtype;

const modelMarkdownMap: Partial<
  Record<ResourceSubtype, Record<string, string>>
> = {
  [ComponentSubtypes.CAMERA]: {
    transform: CAMERATRANSFORMATTRIBUTES,
  },
  [ComponentSubtypes.SERVO]: {
    gpio: SERVOGPIOATTRIBUTES,
  },
  [ServiceSubtypes.MOTION]: {
    builtin: MOTIONATTRIBUTES,
  },
};

export const getMarkdownDocumentationByModel = (
  api: APITriplet | undefined,
  model: ModelTriplet | undefined
) => {
  if (
    api &&
    isBuiltinAPI(api, api.subtype) &&
    model &&
    isBuiltinModel(model, model.name)
  ) {
    return modelMarkdownMap[api.subtype as ResourceSubtype]?.[model.name];
  }
  return undefined;
};
